export default __webpack_public_path__ + "static/media/attractions_itinerary_sample.38d7d0e3.png";